import { render, staticRenderFns } from "./LedgerContent.vue?vue&type=template&id=8e0bbb98&"
import script from "./LedgerContent.vue?vue&type=script&lang=js&"
export * from "./LedgerContent.vue?vue&type=script&lang=js&"
import style0 from "./LedgerContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports